import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../../dispatcher/AdminAppDispatcher';
import AdminConstants from '../../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'QUOTE_DELETED';
let state = {
    pending: false,
    complete: false,
    success: false,
    fail: false,
    error: '',
};
const DeleteQuoteStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    onDeleteQuoteRequest() {
        state = Object.assign(Object.assign({}, state), { pending: true, complete: false, success: false, fail: false });
        this.emitChange();
    },
    onDeleteQuoteSuccess() {
        state = Object.assign(Object.assign({}, state), { pending: false, complete: true, success: true, fail: false });
        this.emitChange();
    },
    onDeleteQuoteFail() {
        state = Object.assign(Object.assign({}, state), { pending: false, complete: true, success: false, fail: true, error });
        this.emitChange();
    },
    //Unused but could be nice to show toast notifications
    //in the future
    retrieveState() {
        return state;
    }
});
DeleteQuoteStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.DELETE_QUOTE_SUCCESS:
            DeleteQuoteStore.onDeleteQuoteSuccess();
            break;
        case ActionTypes.DELETE_QUOTE_FAIL:
            DeleteQuoteStore.onDeleteQuoteFail();
            break;
        case ActionTypes.DELETE_QUOTE_REQUEST:
            DeleteQuoteStore.onDeleteQuoteRequest();
            break;
        default:
            break;
    }
});
export default DeleteQuoteStore;
